import CountUp from "react-countup";
import React from "react";
import ReactDOM from "react-dom/client";
import { useInView } from "react-intersection-observer";

function CounterApp({end, duration, prefix, suffix, decimals}) {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  return (
    <div ref={ref}>
      <CountUp
        start={inView ? 0 : -1}
        end={inView ? end : 0}
        duration={duration || 2}
        prefix={prefix || ""}
        suffix={suffix || ""}
        decimals={decimals}
        scrollSpyOnce
        scrollSpyDelay={400}
        target={1}
      />
    </div>
  );
}

document.addEventListener("DOMContentLoaded", () => {
  const incomePledged = document.getElementById("incomePledged");
  if (incomePledged) {
    const amount = incomePledged.dataset.percentage;
    const animatedChart = incomePledged.querySelector(".chartAnimated");

    const root = document.documentElement;
    root.style.setProperty('--num-sales', amount); // sets the CSS var for the animated arc
    
    if (amount !== undefined && animatedChart) {
      ReactDOM.createRoot(animatedChart).render(
        <CounterApp end={parseFloat(amount)} duration={3} decimals={1} suffix={"%"} />
      );
    }
  }

});